import React from 'react';
import { Skeleton } from '../ui/Skeleton';

export default function SkeletonFormList() {
  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6 max-w-7xl mx-auto animate-pulse">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <Skeleton className="h-7 w-32" rounded="rounded" />
        <Skeleton className="h-9 w-28" rounded="rounded-lg" />
      </div>

      {/* Search bar */}
      <div className="mb-6">
        <Skeleton className="h-9 w-72" rounded="rounded-lg" />
      </div>

      {/* Card grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 p-5">
            <div className="flex items-center justify-between mb-3">
              <Skeleton className="h-5 w-2/3" rounded="rounded" />
              <Skeleton className="h-5 w-14" rounded="rounded-full" />
            </div>
            <Skeleton className="h-3 w-full mb-1" rounded="rounded" />
            <Skeleton className="h-3 w-3/4 mb-4" rounded="rounded" />
            <div className="flex gap-4 mb-4">
              <Skeleton className="h-8 w-20" rounded="rounded-lg" />
              <Skeleton className="h-8 w-20" rounded="rounded-lg" />
              <Skeleton className="h-8 w-20" rounded="rounded-lg" />
            </div>
            <div className="flex items-center justify-between pt-3 border-t border-gray-100 dark:border-gray-700">
              <Skeleton className="h-3 w-24" rounded="rounded" />
              <div className="flex gap-2">
                <Skeleton className="h-7 w-7" rounded="rounded" />
                <Skeleton className="h-7 w-7" rounded="rounded" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
